import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

import { makeStyles } from '@material-ui/core/styles';

import { DbPattionList } from 'lib/api/server';

import NewTableContainer from 'components/molecules/NewTable';
import NewFilterWrap from 'components/molecules/NewFilterWrap';
import FilterCollection from 'components/organisms/FilterCollection';

const useStyles = makeStyles((theme) => ({
  xColor: { color: theme.palette.common.red },
}));

const DbPartition = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  const [initialization, setInitialization] = useState(false);

  let initParam = {
    sort: 'desc',
    order: 'DB_NM',
    sMonth: moment().format('YYYYMM'),
    dbPtYn: 'all',
  };
  const [params, setParams] = useState(initParam);

  const initList = {
    sMonth: [
      {
        label: moment().add(1, 'month').format('YYYY.MM'),
        value: moment().add(1, 'month').format('YYYYMM'),
      },
      {
        label: moment().format('YYYY.MM'),
        value: moment().format('YYYYMM'),
      },
      {
        label: moment().add(-1, 'month').format('YYYY.MM'),
        value: moment().add(-1, 'month').format('YYYYMM'),
      },
      {
        label: moment().add(-2, 'month').format('YYYY.MM'),
        value: moment().add(-2, 'month').format('YYYYMM'),
      },
      {
        label: moment().add(-3, 'month').format('YYYY.MM'),
        value: moment().add(-3, 'month').format('YYYYMM'),
      },
      {
        label: moment().add(-4, 'month').format('YYYY.MM'),
        value: moment().add(-4, 'month').format('YYYYMM'),
      },
      {
        label: moment().add(-5, 'month').format('YYYY.MM'),
        value: moment().add(-5, 'month').format('YYYYMM'),
      },
      {
        label: moment().add(-6, 'month').format('YYYY.MM'),
        value: moment().add(-6, 'month').format('YYYYMM'),
      },
      {
        label: moment().add(-7, 'month').format('YYYY.MM'),
        value: moment().add(-7, 'month').format('YYYYMM'),
      },
      {
        label: moment().add(-8, 'month').format('YYYY.MM'),
        value: moment().add(-8, 'month').format('YYYYMM'),
      },
      {
        label: moment().add(-9, 'month').format('YYYY.MM'),
        value: moment().add(-9, 'month').format('YYYYMM'),
      },
      {
        label: moment().add(-10, 'month').format('YYYY.MM'),
        value: moment().add(-10, 'month').format('YYYYMM'),
      },
      {
        label: moment().add(-11, 'month').format('YYYY.MM'),
        value: moment().add(-11, 'month').format('YYYYMM'),
      },
      {
        label: moment().add(-12, 'month').format('YYYY.MM'),
        value: moment().add(-12, 'month').format('YYYYMM'),
      },
      {
        label: moment().add(-13, 'month').format('YYYY.MM'),
        value: moment().add(-13, 'month').format('YYYYMM'),
      },
    ],
    dbPtYn: [
      { label: t('전체'), value: 'all' },
      { label: t('사용'), value: 'Y' },
      { label: t('미사용'), value: 'N' },
    ],
  };
  const [list] = useState(initList);

  /**
   * 필터 초기화 후 값을 바꿈
   */
  useEffect(() => {
    if (initialization === true) {
      setInitialization(false);
    }
  }, [initialization]);

  /**
   * 필터 초기화
   */
  const handleOnReset = () => {
    setInitialization(true);
    setParams(initParam);
  };

  const getParam = (newParams) => {
    setParams({
      ...params,
      ...newParams,
    });
  };

  // header 및 body 컬럼 커스텀
  const customized = {
    TABLE_NAME: { orderFlag: true },
    DB_NM: { orderFlag: true },
    CYCLE: { bodyStyle: { width: 50 } },
    PART_TYPE: {
      headStyle: { padding: '10px 5px' },
      bodyStyle: { padding: '10px 0' },
      orderFlag: true,
    },
    TABLE_STATE: { merged: true },
    CHECK_DAY_01: {
      makeHead: (headsMap) => {
        return <>01</>;
      },
      makeBody: (rowObj, headsMap) => {
        return rowObj['CHECK_DAY_01'] === 'O' ? (
          rowObj['CHECK_DAY_01']
        ) : (
          <span className={classes.xColor}>{rowObj['CHECK_DAY_01']}</span>
        );
      },
      headStyle: { padding: '10px 5px' },
      bodyStyle: { padding: '10px 0' },
    },
    CHECK_DAY_02: {
      makeHead: (headsMap) => {
        return <>02</>;
      },
      makeBody: (rowObj, headsMap) => {
        return rowObj['CHECK_DAY_02'] === 'O' ? (
          rowObj['CHECK_DAY_02']
        ) : (
          <span className={classes.xColor}>{rowObj['CHECK_DAY_02']}</span>
        );
      },
      headStyle: { padding: '10px 5px' },
      bodyStyle: { padding: '10px 0' },
    },
    CHECK_DAY_03: {
      makeHead: (headsMap) => {
        return <>03</>;
      },
      makeBody: (rowObj, headsMap) => {
        return rowObj['CHECK_DAY_03'] === 'O' ? (
          rowObj['CHECK_DAY_03']
        ) : (
          <span className={classes.xColor}>{rowObj['CHECK_DAY_03']}</span>
        );
      },
      headStyle: { padding: '10px 5px' },
      bodyStyle: { padding: '10px 0' },
    },
    CHECK_DAY_04: {
      makeHead: (headsMap) => {
        return <>04</>;
      },
      makeBody: (rowObj, headsMap) => {
        return rowObj['CHECK_DAY_04'] === 'O' ? (
          rowObj['CHECK_DAY_04']
        ) : (
          <span className={classes.xColor}>{rowObj['CHECK_DAY_04']}</span>
        );
      },
      headStyle: { padding: '10px 5px' },
      bodyStyle: { padding: '10px 0' },
    },
    CHECK_DAY_05: {
      makeHead: (headsMap) => {
        return <>05</>;
      },
      makeBody: (rowObj, headsMap) => {
        return rowObj['CHECK_DAY_05'] === 'O' ? (
          rowObj['CHECK_DAY_05']
        ) : (
          <span className={classes.xColor}>{rowObj['CHECK_DAY_05']}</span>
        );
      },
      headStyle: { padding: '10px 5px' },
      bodyStyle: { padding: '10px 0' },
    },
    CHECK_DAY_06: {
      makeHead: (headsMap) => {
        return <>06</>;
      },
      makeBody: (rowObj, headsMap) => {
        return rowObj['CHECK_DAY_06'] === 'O' ? (
          rowObj['CHECK_DAY_06']
        ) : (
          <span className={classes.xColor}>{rowObj['CHECK_DAY_06']}</span>
        );
      },
      headStyle: { padding: '10px 5px' },
      bodyStyle: { padding: '10px 0' },
    },
    CHECK_DAY_07: {
      makeHead: (headsMap) => {
        return <>07</>;
      },
      makeBody: (rowObj, headsMap) => {
        return rowObj['CHECK_DAY_07'] === 'O' ? (
          rowObj['CHECK_DAY_07']
        ) : (
          <span className={classes.xColor}>{rowObj['CHECK_DAY_07']}</span>
        );
      },
      headStyle: { padding: '10px 5px' },
      bodyStyle: { padding: '10px 0' },
    },
    CHECK_DAY_08: {
      makeHead: (headsMap) => {
        return <>08</>;
      },
      makeBody: (rowObj, headsMap) => {
        return rowObj['CHECK_DAY_08'] === 'O' ? (
          rowObj['CHECK_DAY_08']
        ) : (
          <span className={classes.xColor}>{rowObj['CHECK_DAY_08']}</span>
        );
      },
      headStyle: { padding: '10px 5px' },
      bodyStyle: { padding: '10px 0' },
    },
    CHECK_DAY_09: {
      makeHead: (headsMap) => {
        return <>09</>;
      },
      makeBody: (rowObj, headsMap) => {
        return rowObj['CHECK_DAY_09'] === 'O' ? (
          rowObj['CHECK_DAY_09']
        ) : (
          <span className={classes.xColor}>{rowObj['CHECK_DAY_09']}</span>
        );
      },
      headStyle: { padding: '10px 5px' },
      bodyStyle: { padding: '10px 0' },
    },
    CHECK_DAY_10: {
      makeHead: (headsMap) => {
        return <>10</>;
      },
      makeBody: (rowObj, headsMap) => {
        return rowObj['CHECK_DAY_10'] === 'O' ? (
          rowObj['CHECK_DAY_10']
        ) : (
          <span className={classes.xColor}>{rowObj['CHECK_DAY_10']}</span>
        );
      },
      headStyle: { padding: '10px 5px' },
      bodyStyle: { padding: '10px 0' },
    },
    CHECK_DAY_11: {
      makeHead: (headsMap) => {
        return <>11</>;
      },
      makeBody: (rowObj, headsMap) => {
        return rowObj['CHECK_DAY_11'] === 'O' ? (
          rowObj['CHECK_DAY_11']
        ) : (
          <span className={classes.xColor}>{rowObj['CHECK_DAY_11']}</span>
        );
      },
      headStyle: { padding: '10px 5px' },
      bodyStyle: { padding: '10px 0' },
    },
    CHECK_DAY_12: {
      makeHead: (headsMap) => {
        return <>12</>;
      },
      makeBody: (rowObj, headsMap) => {
        return rowObj['CHECK_DAY_12'] === 'O' ? (
          rowObj['CHECK_DAY_12']
        ) : (
          <span className={classes.xColor}>{rowObj['CHECK_DAY_12']}</span>
        );
      },
      headStyle: { padding: '10px 5px' },
      bodyStyle: { padding: '10px 0' },
    },
    CHECK_DAY_13: {
      makeHead: (headsMap) => {
        return <>13</>;
      },
      makeBody: (rowObj, headsMap) => {
        return rowObj['CHECK_DAY_13'] === 'O' ? (
          rowObj['CHECK_DAY_13']
        ) : (
          <span className={classes.xColor}>{rowObj['CHECK_DAY_13']}</span>
        );
      },
      headStyle: { padding: '10px 5px' },
      bodyStyle: { padding: '10px 0' },
    },
    CHECK_DAY_14: {
      makeHead: (headsMap) => {
        return <>14</>;
      },
      makeBody: (rowObj, headsMap) => {
        return rowObj['CHECK_DAY_14'] === 'O' ? (
          rowObj['CHECK_DAY_14']
        ) : (
          <span className={classes.xColor}>{rowObj['CHECK_DAY_14']}</span>
        );
      },
      headStyle: { padding: '10px 5px' },
      bodyStyle: { padding: '10px 0' },
    },
    CHECK_DAY_15: {
      makeHead: (headsMap) => {
        return <>15</>;
      },
      makeBody: (rowObj, headsMap) => {
        return rowObj['CHECK_DAY_15'] === 'O' ? (
          rowObj['CHECK_DAY_15']
        ) : (
          <span className={classes.xColor}>{rowObj['CHECK_DAY_15']}</span>
        );
      },
      headStyle: { padding: '10px 5px' },
      bodyStyle: { padding: '10px 0' },
    },
    CHECK_DAY_16: {
      makeHead: (headsMap) => {
        return <>16</>;
      },
      makeBody: (rowObj, headsMap) => {
        return rowObj['CHECK_DAY_16'] === 'O' ? (
          rowObj['CHECK_DAY_16']
        ) : (
          <span className={classes.xColor}>{rowObj['CHECK_DAY_16']}</span>
        );
      },
      headStyle: { padding: '10px 5px' },
      bodyStyle: { padding: '10px 0' },
    },
    CHECK_DAY_17: {
      makeHead: (headsMap) => {
        return <>17</>;
      },
      makeBody: (rowObj, headsMap) => {
        return rowObj['CHECK_DAY_17'] === 'O' ? (
          rowObj['CHECK_DAY_17']
        ) : (
          <span className={classes.xColor}>{rowObj['CHECK_DAY_17']}</span>
        );
      },
      headStyle: { padding: '10px 5px' },
      bodyStyle: { padding: '10px 0' },
    },
    CHECK_DAY_18: {
      makeHead: (headsMap) => {
        return <>18</>;
      },
      makeBody: (rowObj, headsMap) => {
        return rowObj['CHECK_DAY_18'] === 'O' ? (
          rowObj['CHECK_DAY_18']
        ) : (
          <span className={classes.xColor}>{rowObj['CHECK_DAY_18']}</span>
        );
      },
      headStyle: { padding: '10px 5px' },
      bodyStyle: { padding: '10px 0' },
    },
    CHECK_DAY_19: {
      makeHead: (headsMap) => {
        return <>19</>;
      },
      makeBody: (rowObj, headsMap) => {
        return rowObj['CHECK_DAY_19'] === 'O' ? (
          rowObj['CHECK_DAY_19']
        ) : (
          <span className={classes.xColor}>{rowObj['CHECK_DAY_19']}</span>
        );
      },
      headStyle: { padding: '10px 5px' },
      bodyStyle: { padding: '10px 0' },
    },
    CHECK_DAY_20: {
      makeHead: (headsMap) => {
        return <>20</>;
      },
      makeBody: (rowObj, headsMap) => {
        return rowObj['CHECK_DAY_20'] === 'O' ? (
          rowObj['CHECK_DAY_20']
        ) : (
          <span className={classes.xColor}>{rowObj['CHECK_DAY_20']}</span>
        );
      },
      headStyle: { padding: '10px 5px' },
      bodyStyle: { padding: '10px 0' },
    },
    CHECK_DAY_21: {
      makeHead: (headsMap) => {
        return <>21</>;
      },
      makeBody: (rowObj, headsMap) => {
        return rowObj['CHECK_DAY_21'] === 'O' ? (
          rowObj['CHECK_DAY_21']
        ) : (
          <span className={classes.xColor}>{rowObj['CHECK_DAY_21']}</span>
        );
      },
      headStyle: { padding: '10px 5px' },
      bodyStyle: { padding: '10px 0' },
    },
    CHECK_DAY_22: {
      makeHead: (headsMap) => {
        return <>22</>;
      },
      makeBody: (rowObj, headsMap) => {
        return rowObj['CHECK_DAY_22'] === 'O' ? (
          rowObj['CHECK_DAY_22']
        ) : (
          <span className={classes.xColor}>{rowObj['CHECK_DAY_22']}</span>
        );
      },
      headStyle: { padding: '10px 5px' },
      bodyStyle: { padding: '10px 0' },
    },
    CHECK_DAY_23: {
      makeHead: (headsMap) => {
        return <>23</>;
      },
      makeBody: (rowObj, headsMap) => {
        return rowObj['CHECK_DAY_23'] === 'O' ? (
          rowObj['CHECK_DAY_23']
        ) : (
          <span className={classes.xColor}>{rowObj['CHECK_DAY_23']}</span>
        );
      },
      headStyle: { padding: '10px 5px' },
      bodyStyle: { padding: '10px 0' },
    },
    CHECK_DAY_24: {
      makeHead: (headsMap) => {
        return <>24</>;
      },
      makeBody: (rowObj, headsMap) => {
        return rowObj['CHECK_DAY_24'] === 'O' ? (
          rowObj['CHECK_DAY_24']
        ) : (
          <span className={classes.xColor}>{rowObj['CHECK_DAY_24']}</span>
        );
      },
      headStyle: { padding: '10px 5px' },
      bodyStyle: { padding: '10px 0' },
    },
    CHECK_DAY_25: {
      makeHead: (headsMap) => {
        return <>25</>;
      },
      makeBody: (rowObj, headsMap) => {
        return rowObj['CHECK_DAY_25'] === 'O' ? (
          rowObj['CHECK_DAY_25']
        ) : (
          <span className={classes.xColor}>{rowObj['CHECK_DAY_25']}</span>
        );
      },
      headStyle: { padding: '10px 5px' },
      bodyStyle: { padding: '10px 0' },
    },
    CHECK_DAY_26: {
      makeHead: (headsMap) => {
        return <>26</>;
      },
      makeBody: (rowObj, headsMap) => {
        return rowObj['CHECK_DAY_26'] === 'O' ? (
          rowObj['CHECK_DAY_26']
        ) : (
          <span className={classes.xColor}>{rowObj['CHECK_DAY_26']}</span>
        );
      },
      headStyle: { padding: '10px 5px' },
      bodyStyle: { padding: '10px 0' },
    },
    CHECK_DAY_27: {
      makeHead: (headsMap) => {
        return <>27</>;
      },
      makeBody: (rowObj, headsMap) => {
        return rowObj['CHECK_DAY_27'] === 'O' ? (
          rowObj['CHECK_DAY_27']
        ) : (
          <span className={classes.xColor}>{rowObj['CHECK_DAY_27']}</span>
        );
      },
      headStyle: { padding: '10px 5px' },
      bodyStyle: { padding: '10px 0' },
    },
    CHECK_DAY_28: {
      makeHead: (headsMap) => {
        return <>28</>;
      },
      makeBody: (rowObj, headsMap) => {
        return rowObj['CHECK_DAY_28'] === 'O' ? (
          rowObj['CHECK_DAY_28']
        ) : (
          <span className={classes.xColor}>{rowObj['CHECK_DAY_28']}</span>
        );
      },
      headStyle: { padding: '10px 5px' },
      bodyStyle: { padding: '10px 0' },
    },
    CHECK_DAY_29: {
      makeHead: (headsMap) => {
        return <>29</>;
      },
      makeBody: (rowObj, headsMap) => {
        return rowObj['CHECK_DAY_29'] === 'O' ? (
          rowObj['CHECK_DAY_29']
        ) : (
          <span className={classes.xColor}>{rowObj['CHECK_DAY_29']}</span>
        );
      },
      headStyle: { padding: '10px 5px' },
      bodyStyle: { padding: '10px 0' },
    },
    CHECK_DAY_30: {
      makeHead: (headsMap) => {
        return <>30</>;
      },
      makeBody: (rowObj, headsMap) => {
        return rowObj['CHECK_DAY_30'] === 'O' ? (
          rowObj['CHECK_DAY_30']
        ) : (
          <span className={classes.xColor}>{rowObj['CHECK_DAY_30']}</span>
        );
      },
      headStyle: { padding: '10px 5px' },
      bodyStyle: { padding: '10px 0' },
    },
    CHECK_DAY_31: {
      makeHead: (headsMap) => {
        return <>31</>;
      },
      makeBody: (rowObj, headsMap) => {
        return rowObj['CHECK_DAY_31'] === 'O' ? (
          rowObj['CHECK_DAY_31']
        ) : (
          <span className={classes.xColor}>{rowObj['CHECK_DAY_31']}</span>
        );
      },
      headStyle: { padding: '10px 5px' },
      bodyStyle: { padding: '10px 0' },
    },
  };

  return (
    <>
      <NewFilterWrap handleOnReset={handleOnReset}>
        <FilterCollection
          label={t('날짜선택')}
          name="sMonth"
          params={params}
          value={params.sMonth}
          type="select"
          list={list.sMonth}
          callBack={getParam}
          labelKey="label"
          valueKey="value"
        />
        <FilterCollection
          label={t('사용여부')}
          name="dbPtYn"
          params={params}
          value={params.dbPtYn}
          type="radio"
          list={list.dbPtYn}
          callBack={getParam}
          labelKey="label"
          valueKey="value"
        />
      </NewFilterWrap>
      <NewTableContainer
        dataReqPromise={DbPattionList}
        params={params}
        getParam={getParam}
        excelTotalRemoval
        customized={customized}
        useSearch={false}
        useTotal={false}
        useFetch={false}
        paramsInHead
        reFetchHead
      />
    </>
  );
};

export default DbPartition;
